<main class="login-page d-flex justify-content-center px-3 pt-2">
    <section class="login-panel w-100">
        <header class="login-header d-flex flex-column mb-4">
            <h3 class="p-0 mb-0">E-mail verstuurd</h3>
            <p class="mb-0">
                We hebben een code verstuurd naar <span class="mail">{{ loginForm.value.email }}</span>
                .
            </p>
        </header>

        <form [formGroup]="loginForm" (ngSubmit)="validateCode()" class="login-form d-flex flex-column">
            <section class="login-section mb-4">
                <mat-form-field appearance="fill" class="w-100" id="code">
                    <input
                        (keyup.enter)="validateCode()"
                        (paste)="pasteCode($event)"
                        [decimalInput]="0"
                        appDecimalInput
                        autocomplete="one-time-code"
                        formControlName="code"
                        matInput
                        maxlength="6"
                        name="code"
                        placeholder="Voer de code hier in"
                        type="number" />
                    <mat-label>Code uit e-mail</mat-label>
                </mat-form-field>

                @if (errorMessage) {
                    <div class="text-danger small mt-n2 mb-2">{{ errorMessage }}</div>
                }

                <div class="login-actions d-flex flex-column mt-1">
                    <button
                        [disabled]="validating || loginForm.invalid"
                        class="loading big dark w-100"
                        color="primary"
                        mat-raised-button
                        type="submit">
                        @if (!validating) {
                            Bevestigen
                        } @else {
                            We controleren je code
                            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                        }
                    </button>

                    @if (!errorMessage) {
                        <div class="mb-0 small text-center">Geen e-mail ontvangen? Controleer je spam</div>
                    } @else {
                        <button (click)="resendCode()" class="w-100" color="primary" mat-raised-button type="button">
                            Nieuwe code aanvragen
                        </button>
                    }
                </div>
            </section>
        </form>
    </section>
</main>
